import axios, { AxiosError, Method } from 'axios';
import { useEffect, useState } from 'react';

import AuthModule from '../auth/AuthModule';

export const useFetch = (
  method: Method,
  url: any,
  body: any,
  withAuth = true,
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState(null);
  const [serverError, setServerError] = useState(null);

  useEffect(() => {
    if (!url) {
      return;
    }
    setIsLoading(true);
    const fetchData = async () => {
      try {
        if (withAuth) {
          const b2cToken =
            await AuthModule.getInstance().getProfileTokenRedirect();
          // have to use ignore
          const resp = await axios({
            method,
            url,
            data: body,
            headers: {
              Authorization: `Bearer ${b2cToken}`,
              'Ocp-Apim-Subscription-Key': `${process.env.REACT_APP_API_KEY}`,
            },
          });
          const data = await resp?.data;
          setApiData(data);
        } else {
          const resp = await axios({
            method,
            url,
            data: body,
            headers: {
              'Ocp-Apim-Subscription-Key': `${process.env.REACT_APP_API_KEY}`,
            },
          });
          const data = await resp?.data;
          setApiData(data);
        }
        setIsLoading(false);
      } catch (error) {
        let errorCode;
        const axiosError = error as AxiosError;
        if (axiosError) errorCode = axiosError?.response?.data?.detail?.error;

        if (errorCode) {
          setServerError(errorCode as any);
        } else {
          // fallback
          setServerError(error as any);
        }
        setIsLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return { isLoading, apiData, serverError };
};
